import {ReactNode} from 'react';
import {connect} from 'react-redux';

import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {RepositionPopoverProps} from '../../../../../../libs/shared/ui/src/components/popovers/repositionPopover';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ResolveDispatchProps} from '../../../../../helpers/reduxHelpers';
import {
  getCustomSnoozes,
  getReminderPresets,
  getReminderValues,
  getTimeFormat,
} from '../../../../../store/data/preferences/preferencesSelectors';
import {navigateToSnoozesAction} from '../../../../../store/stateless/navigationActions';
import {FutureTimeDropdown} from '../../../../common/futureTime/futureTimeDropdown';

/*
 * Props.
 */

interface ReminderDropdownContainerProps extends RepositionPopoverProps {
  title: ReactNode;
  selectButton: ReactNode;
  onValueSelect: HandlerOf<number>;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  values: getReminderValues,
  reminderPresets: getReminderPresets,
  customSnoozes: getCustomSnoozes,
  timeFormat: getTimeFormat,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToSnoozesAction,
}));

function mergeProps(
  stateProps: ResolveStateProps<typeof mapStateToProps>,
  dispatchProps: ResolveDispatchProps<typeof mapDispatchToProps>,
  ownProps: ReminderDropdownContainerProps,
) {
  const onOpenSnoozesClick = () => dispatchProps.navigateToLink();

  return {
    ...stateProps,
    ...ownProps,
    onOpenSnoozesClick,
  };
}

export const ReminderDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(FutureTimeDropdown);
